export const MIDDLE_ITEM_OFFSET_WIDTH_TO_ADD_ELLIPSES = 30;
export const MOBILE_DRAWER_TIMEOUT_FOR_SIDEPANEL_SWIPE = 10;

export const KINDS = {
  user: 'User',
  account: 'Account',
  role: 'Role',
  entitlement: 'Entitlement',
  endpoint: 'Endpoint',
};
